import { useState, createContext, FC, useEffect, ReactNode } from 'react';
import { ThemeProvider } from '@mui/material';
import { themeCreator } from './base';
import { StylesProvider } from '@mui/styles';

// Define missing interfaces
type ThemeContextValue = (themeName: string) => void;

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeContext = createContext<ThemeContextValue>(
  {} as ThemeContextValue
);

export const ThemeProviderWrapper: FC<ThemeProviderProps> = ({ children }) => {
  const [themeName, setThemeNameInternal] = useState('AccsoRailTheme');

  useEffect(() => {
    const curThemeName =
      window.localStorage.getItem('appTheme') || 'AccsoRailTheme';
    setThemeNameInternal(curThemeName);
  }, []);

  const setThemeName = (newThemeName: string): void => {
    setThemeNameInternal(newThemeName);
    window.localStorage.setItem('appTheme', newThemeName);
  };

  const theme = themeCreator(themeName);

  return (
    <StylesProvider injectFirst>
      <ThemeContext.Provider value={setThemeName}>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      </ThemeContext.Provider>
    </StylesProvider>
  );
};

export default ThemeProviderWrapper;
